import { useEffect, useState } from "react"
import { chaveArmazenamentoIdSessao } from "../../utils/Constantes"

export const useContadorSessaoExpirada = (
	tempoRenovarSessao,
	sessaoExpirada,
	atualizarDadosAcesso,
	mostradorTempoSessao,
	dispatch
) => {
	const [contadorSessaoExpirada, setContadorSessaoExpirada] = useState(tempoRenovarSessao)
	const [modalAberto, setModalAberto] = useState(sessaoExpirada)

	useEffect(() => {
		setModalAberto(sessaoExpirada)
	}, [sessaoExpirada])

	useEffect(() => {
		setContadorSessaoExpirada(tempoRenovarSessao)
	}, [tempoRenovarSessao])

	useEffect(() => {
		if (sessaoExpirada) {
			let interval = setInterval(() => {
				setContadorSessaoExpirada((preSecond) => {
					if (preSecond) {
						if (preSecond <= 1) {
							atualizarDadosAcesso(null)(dispatch)
							return preSecond
						} else {
							return preSecond - 1
						}
					} else {
						clearInterval(interval)
					}
				})
			}, 1000)
		}
	}, [sessaoExpirada, tempoRenovarSessao, atualizarDadosAcesso, dispatch])

	const dadosModalSessaoExpirar = {
		titulo: `Sua sessão vai expirar. Deseja renovar?`,
		preTitulo: mostradorTempoSessao(contadorSessaoExpirada),
		botaoPrincipal: {
			texto: "Confirmar",
			acao: () => {
				atualizarDadosAcesso(localStorage.getItem(chaveArmazenamentoIdSessao))(dispatch)
			},
		},
		botaoSecundario: {
			texto: "Sair",
			acao: () => {
				atualizarDadosAcesso(null)(dispatch)
			},
		},
		iconeFechar: false,
		tipoErro: false,
		modalAberto: modalAberto,
		maxWidth: "xs",
		desabilitarCliqueForaModal: true,
	}

	return dadosModalSessaoExpirar
}
